import React from 'react';

const getComponent = key => require(`components/ConceptBlocks/${key.toLowerCase()}`);

export default function Block({ type, ...props }) {
  const { Component } = getComponent(type);

  return <Component {...props} />;
}
